import React from 'react';
import { observer } from 'mobx-react';
import { cities } from '../data/data';

import ProfileImage from '../assets/profile.png';

@observer
class Header extends React.Component {
    render() {
        const { onTypeSelected } = this.props;

        return (
            <div style={styles.container}>
                <div style={styles.header}>
                    <div style={styles.section}>
                    </div>

                    <div style={styles.seperator}></div>

                    <div style={{...styles.section, ...styles.secondSection}}>
                        <div style={styles.secondSectionContent}>
                            <div>Filters:</div>
                            <div>
                                <select name="" id="" style={styles.select} onChange={(e) => onTypeSelected(e)}>
                                    <option hidden>Type</option>
                                    <option value='all'>All Types</option>
                                    <option value='city'>City</option>
                                    <option value='landmark'>Landmark</option>
                                    <option value='lakes'>Lakes</option>
                                </select>
                            </div>
                        </div>
                        <img src={ProfileImage} style={styles.profile} />
                    </div>

                </div>
            </div>
        )
    }
}

const styles = {
    container: {
        height: 90
    },
    header: { 
       display: 'flex', 
       flex: 1,
       boxShadow: '0px 1px 4px 0px black'
    },
    section: {
        display: 'flex',
        flex: 1,
        padding: 20,
        justifyContent: 'space-evenly',
        alignItems: 'center'
    },
    secondSection: {
        justifyContent: 'space-between',
        paddingLeft: 40,
        paddingRight: 40
    },
    secondSectionContent: {
        display: 'flex',
        alignItems: 'center'
    },
    seperator: {
        width: 1,
        backgroundColor: 'black'
    },
    select: {
        width: 200,
        margin: 10,
        padding: 5
    },
    clear: {
        cursor: 'pointer',
        fontWeight: 'bold',
        textDecoration: 'underline',
        width: 38
    },
    profile: {
        height: 30,
        cursor: 'pointer'
    }
}

export default Header
